import { apiFetch } from './api'

export interface SurveyStatus {
  submitted: boolean
  submittedAt: string | null
}

export async function fetchSurveyStatus(type: string): Promise<SurveyStatus> {
  const res = await apiFetch(`/surveys/status?type=${encodeURIComponent(type)}`)
  if (!res.ok) return { submitted: false, submittedAt: null }
  return res.json()
}

export type SubmitResult =
  | { ok: true; submittedAt: string }
  | { ok: false; status: number; error: string; submittedAt?: string }

export async function submitSurvey(
  type: string,
  responses: Record<string, unknown>,
): Promise<SubmitResult> {
  const res = await apiFetch('/surveys', {
    method: 'POST',
    body: JSON.stringify({ surveyType: type, responses }),
  })
  const data = await res.json().catch(() => ({}))
  if (res.ok) {
    return { ok: true, submittedAt: data.survey?.createdAt ?? new Date().toISOString() }
  }
  return { ok: false, status: res.status, error: data.error ?? 'Submit failed', submittedAt: data.submittedAt }
}
